import {
	CARD_PROVIDER_BADGE_THEME,
	CARD_PROVIDER_BADGE_VIEWBOX,
	type CardProviderBadgeName,
} from '@/components/card-provider-icons/card-provider-badge-theme';

interface CardProviderBadgeProps {
	provider: CardProviderBadgeName;
	className?: string;
}

export function CardProviderBadge({ provider, className }: CardProviderBadgeProps) {
	const { bg, text } = CARD_PROVIDER_BADGE_THEME[provider];

	return (
		<svg viewBox={CARD_PROVIDER_BADGE_VIEWBOX} fill='none' xmlns='http://www.w3.org/2000/svg' className={className} aria-hidden>
			<rect width='52' height='14' rx='2.5' fill={bg} />
			<text
				x='26'
				y='7.3'
				textAnchor='middle'
				dominantBaseline='middle'
				fill={text}
				fontFamily='system-ui, Arial, sans-serif'
				fontWeight='700'
				fontSize='7.2'
				letterSpacing='0.1'
			>
				{provider}
			</text>
		</svg>
	);
}
